import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const UPDATE_CONVERSATION_TITLE = 'UPDATE_CONVERSATION_TITLE';
export const UPDATE_CONVERSATION_TITLE_SUCCESS =
	'UPDATE_CONVERSATION_TITLE_SUCCESS';
export const UPDATE_CONVERSATION_TITLE_FAIL = 'UPDATE_CONVERSATION_TITLE_FAIL';
export const UPDATE_CONVERSATION_TITLE_RESET =
	'UPDATE_CONVERSATION_TITLE_RESET';

export const updateConversationTitle = (params) => {
	return {
		type: UPDATE_CONVERSATION_TITLE,
		params,
	};
};

export const updateConversationTitleSuccess = (response) => {
	return {
		type: UPDATE_CONVERSATION_TITLE_SUCCESS,
		response,
	};
};

export const updateConversationTitleFail = (response) => {
	return {
		type: UPDATE_CONVERSATION_TITLE_FAIL,
		response,
	};
};

export const updateConversationTitleReset = () => {
	return {
		type: UPDATE_CONVERSATION_TITLE_RESET,
	};
};

export const updateConversationTitleApi = (data) => {
	return (dispatch) => {
		dispatch(updateConversationTitle());
		axios
			.post(
				`${config.api.base_url}/voice-assistance/update-title`,
				data,
				{
					headers: {
						Authorization: 'Bearer ' + getUserToken(),
					},
				},
			)
			.then((response) => {
				const updateData = response.data;
				dispatch(updateConversationTitleSuccess(updateData));
			})
			.catch((error) => {
				const errorMsg = error.response
					? error.response.data
					: error.message;
				dispatch(updateConversationTitleFail(errorMsg));
			});
	};
};
